import classNames from 'classnames'

const ScreenWrapper = ({ fullpageclass, children }) => {
    const wrapperClass = classNames([fullpageclass])

    return <div className={wrapperClass}>{children}</div>
}

export default ScreenWrapper
